import { Requests } from '@nx-smartmonkey/shared/helpers';
import { Route } from '../../domain/route/Route';
import { Stop } from '../../domain/stop/Stop';
import { RouteMapper } from '../../mappers/RouteMapper';
import StopMapper from '../../mappers/StopMapper';
import { SessionRepository } from '../session/SessionRepository';
import { StopRepository } from './StopRepository';

export class StopRepositoryApi implements StopRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}

  async validatePin({ stop, pin }: { stop: Stop; pin: string }): Promise<void> {
    await this.requests.post({
      uri: `/drivers/v3/stop/${stop.id}/pin`,
      data: {
        pin,
      },
      headers: await this.sessionRepository.getAuthenticationHeader(),
    });
  }

  async sendPin({ stop, method }: { stop: Stop; method: `email` | `sms` }): Promise<void> {
    await this.requests.post({
      uri: `/drivers/v3/stop/${stop.id}/pin/send`,
      data: {
        method,
      },
      headers: await this.sessionRepository.getAuthenticationHeader(),
    });
  }

  async updateStop({ newStop, stopId }: { newStop: Stop; stopId: string }): Promise<Stop> {
    const response = await this.requests.put({
      uri: `/drivers/v3/stop/${stopId}`,
      data: {
        newStop: StopMapper.toRepository(newStop),
      },
      headers: {
        ...(await this.sessionRepository.getAuthenticationHeader()),
      },
    });

    return StopMapper.toDomain(response.data);
  }

  async deleteStop({ stop }: { stop: Stop }): Promise<Route> {
    const response = await this.requests.delete({
      uri: `/drivers/v3/stop/${stop.id}`,
      headers: {
        ...(await this.sessionRepository.getAuthenticationHeader()),
      },
    });

    return RouteMapper.toDomain(response.data);
  }

  async deleteStops({ stops }: { stops: string[] }): Promise<Route> {
    const response = await this.requests.put({
      uri: `/drivers/v3/stops`,
      data: {
        stops_ids: stops,
      },
      headers: {
        ...(await this.sessionRepository.getAuthenticationHeader()),
      },
    });

    return RouteMapper.toDomain(response.data);
  }
  async copyStops({
    route_destination_id,
    route_origin_id,
    stops,
  }: {
    route_destination_id: string;
    route_origin_id: string;
    stops: string[];
  }): Promise<Route> {
    const response = await this.requests.post({
      uri: `/drivers/v3/stops/copy/${route_destination_id}`,
      data: {
        route_origin_id,
        stop_ids: stops,
      },
      headers: {
        ...(await this.sessionRepository.getAuthenticationHeader()),
      },
    });

    return RouteMapper.toDomain(response.data);
  }
}
